// PrivilegeService.js

import { HTTP } from "@/utils/http-common"

export default {
  async getAll(queryArgs = null) {
    const path = `/business/privileges`
    let results = (await HTTP.get(path, { params: queryArgs })).data
    return results
  },

  async getUserProjectPrivileges(userId) {
    const path = `/business/${userId}/privileges`
    // const params = { user_id, project_id }
    return (await HTTP.get(path)).data
  },

  async get(privilegeId) {
    const path = `/business/privileges/${privilegeId}`
    return (await HTTP.get(path)).data
  },

  async post(userId, data) {
    const path = `/business/${userId}/privileges`
    return (await HTTP.post(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/business/privileges/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(privilegeId) {
    const path = `/business/privileges/${privilegeId}`
    return (await HTTP.delete(path)).data
  }
}
